import { render } from "./RoomHeader.vue?vue&type=template&id=dc904b60&scoped=true"
import script from "./RoomHeader.vue?vue&type=script&lang=js"
export * from "./RoomHeader.vue?vue&type=script&lang=js"

import "./RoomHeader.vue?vue&type=style&index=0&id=dc904b60&lang=scss&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc904b60"]])

export default __exports__